export default function Contact() {
  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Entre em Contato</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Estamos Aqui Para Ajudar
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Tem alguma questão ou quer saber mais sobre os nossos serviços? Entre em contato connosco
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="space-y-8">
              <div className="flex items-start gap-6 group cursor-pointer">
                <div className="w-14 h-14 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-mail-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Email</h3>
                  <a 
                    href="mailto:consultadoriaeservicosemsaude@gmail.com"
                    className="text-base text-gray-600 hover:text-teal-600 transition-colors"
                  >
                    consultadoriaeservicosemsaude@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6 group cursor-pointer">
                <div className="w-14 h-14 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-phone-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Telemóvel</h3>
                  <a 
                    href="tel:919214659"
                    className="text-base text-gray-600 hover:text-teal-600 transition-colors"
                  >
                    919 214 659
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6 group cursor-pointer">
                <div className="w-14 h-14 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-time-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Horário de Atendimento</h3>
                  <p className="text-base text-gray-600">Segunda a Sexta: 9h - 18h</p>
                  <p className="text-sm text-gray-500 mt-1">Resposta em 24 horas</p>
                </div>
              </div>
            </div>

            <div className="mt-12 p-8 bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Pronto Para Começar?
              </h3>
              <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                Agende uma reunião gratuita com a nossa equipa e descubra como podemos ajudar a transformar o seu projeto de saúde em realidade
              </p>
              <button 
                onClick={() => {
                  const element = document.getElementById('reuniao');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="bg-teal-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Agendar Reunião Gratuita
                <i className="ri-calendar-line"></i>
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/f29a89dee6d14f2c535654e0b1173c83.jpg"
                alt="Contacto"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}